/* Real browser history only; never reads customer artwork, form values or cart data. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.customElements || root.customElements.get('hah-product-recent')) return;

  class RecentProducts extends root.HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._onStorage = (event) => { if (event.key === api.KEY || event.key === null) this.refresh(false); };
      root.addEventListener('storage', this._onStorage);
      this.refresh(!this._visited);
      this._visited = true;
    }
    disconnectedCallback() {
      this._connected = false;
      if (this._abort) this._abort.abort();
      root.removeEventListener('storage', this._onStorage);
    }
    async refresh(recordVisit) {
      if (this._abort) this._abort.abort();
      var controller = new AbortController(); this._abort = controller;
      var grid = this.querySelector('[data-hah-recent-items]');
      var status = this.querySelector('[data-hah-recent-status]');
      if (!grid || !status) return;
      function message(text) { status.textContent = text; status.hidden = false; }
      try {
        var config = api.configuration(this.dataset, root.location.origin);
        var storage;
        try { storage = root.localStorage; } catch (_) { storage = null; }
        var history = api.readHistory(storage, config);
        grid.replaceChildren(); grid.hidden = true;
        if (!history.available) { message('Recently viewed is unavailable in this browser.'); return; }
        var other = history.items.filter(item => item.id !== config.current.id && item.handle !== config.current.handle);
        message(other.length ? 'Loading recently viewed products…' : 'Products you view will appear here as you browse.');
        var candidates = recordVisit ? [config.current].concat(other) : other;
        var results = await api.verifyInOrder(candidates, config, root.fetch.bind(root), controller.signal);
        if (!this._connected || controller.signal.aborted || this._abort !== controller) return;
        var valid = results.filter(result => result.product).map(result => result.product);
        if (recordVisit) {
          var current = valid.find(item => item.id === config.current.id);
          if (current) api.recordCurrent(storage, history, current, config);
        }
        var displayed = valid.filter(item => item.id !== config.current.id && item.handle !== config.current.handle).slice(0, config.limit);
        api.renderCards(grid, displayed, this.ownerDocument);
        grid.hidden = !displayed.length;
        status.hidden = !!displayed.length;
        if (!displayed.length && other.length) {
          var networkFailure = results.some(result => result.unavailable);
          message(networkFailure ? 'Recently viewed products are unavailable right now. Please try again later.' : 'No other recently viewed products are currently available.');
        }
      } catch (_) {
        if (!controller.signal.aborted && this._abort === controller) message('Recently viewed is unavailable right now.');
      }
    }
  }
  root.customElements.define('hah-product-recent', RecentProducts);
}(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var KEY = 'hah_recently_viewed_products';
  var handlePattern = /^[a-z0-9][a-z0-9-]{0,254}$/;
  function identifier(value) {
    if (typeof value === 'number' && (!Number.isSafeInteger(value) || value <= 0)) return null;
    var id = String(value == null ? '' : value);
    return /^[1-9][0-9]{0,19}$/.test(id) ? id : null;
  }
  function configuration(data, pageOrigin) {
    var origin = new URL(data.publicOrigin);
    if (origin.protocol !== 'https:' || origin.username || origin.password || origin.port || origin.pathname !== '/' || origin.search || origin.hash) throw Error('Invalid storefront');
    var route = data.routeRoot || '/';
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(route)) route = '/';
    var id = identifier(data.currentId), handle = data.currentHandle;
    if (!id || typeof handle !== 'string' || !handlePattern.test(handle)) throw Error('Invalid product');
    var page = new URL(pageOrigin);
    var previewHost = identifier(data.shopId) && new RegExp('^[a-z0-9]{16}-' + data.shopId + '\\.shopifypreview\\.com$').test(page.hostname);
    var sameShop = page.protocol === 'https:' && !page.port && (page.origin === origin.origin || previewHost);
    return {origin: origin.origin, pageOrigin: page.origin, verifyOrigin: sameShop ? page.origin : origin.origin, route: route,
      currency: /^[A-Z]{3}$/.test(data.currency || '') ? data.currency : null,
      current: {id: id, handle: handle, url: route + 'products/' + handle},
      limit: Math.max(2, Math.min(12, Number(data.limit) || 4))};
  }
  function normalize(item, config) {
    if (!item || typeof item !== 'object' || !identifier(item.id) || typeof item.url !== 'string' || item.url.length > 2048) return null;
    var url;
    try { url = new URL(item.url, config.origin); } catch (_) { return null; }
    if (![config.origin, config.pageOrigin].includes(url.origin) || url.username || url.password) return null;
    if (url.searchParams.has('preview_key') || url.searchParams.has('preview_theme_id')) return null;
    var match = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[a-z0-9-]+\/)?products\/([a-z0-9][a-z0-9-]{0,254})\/?$/i.exec(url.pathname);
    if (!match || !handlePattern.test(match[1])) return null;
    return {id: identifier(item.id), handle: match[1], url: config.route + 'products/' + match[1],
      title: typeof item.title === 'string' ? item.title.slice(0, 1000) : '', image: imageUrl(item.image, config),
      price: Number.isSafeInteger(item.price) && item.price >= 0 ? item.price : null,
      currency: /^[A-Z]{3}$/.test(item.currency || '') ? item.currency : null};
  }
  function readHistory(storage, config) {
    var raw;
    try { if (!storage) throw Error(); raw = storage.getItem(KEY); } catch (_) { return {available: false, raw: null, items: []}; }
    try {
      if (raw && raw.length > 256000) throw Error();
      var value = JSON.parse(raw || '[]'); if (!Array.isArray(value)) throw Error();
      var ids = new Set(), handles = new Set(), items = [];
      for (var row of value.slice(0, 100)) {
        var item = normalize(row, config);
        if (!item || ids.has(item.id) || handles.has(item.handle)) continue;
        ids.add(item.id); handles.add(item.handle); items.push(item);
        if (items.length === 12) break;
      }
      return {available: true, raw: raw, items: items};
    } catch (_) { return {available: false, raw: raw, items: []}; }
  }
  function imageUrl(value, config) {
    if (typeof value !== 'string' || value.length > 4096) return '';
    try {
      var url = new URL(value, config.origin);
      if (url.protocol !== 'https:' || url.username || url.password || url.searchParams.has('preview_key')) return '';
      return url.origin === config.origin || url.hostname === 'cdn.shopify.com' ? url.href : '';
    } catch (_) { return ''; }
  }
  function publicProduct(value, candidate, config) {
    if (!value || typeof value !== 'object' || identifier(value.id) !== candidate.id || value.handle !== candidate.handle
      || typeof value.title !== 'string' || !value.title.trim() || value.title.length > 1000
      || typeof value.published_at !== 'string' || !Number.isFinite(Date.parse(value.published_at)) || Date.parse(value.published_at) > Date.now()) return null;
    return {id: candidate.id, handle: candidate.handle, title: value.title,
      url: config.route + 'products/' + candidate.handle,
      href: config.origin + config.route + 'products/' + candidate.handle,
      image: imageUrl(value.featured_image, config),
      price: config.verifyOrigin === config.pageOrigin && Number.isSafeInteger(value.price) && value.price >= 0 ? value.price : null,
      currency: config.verifyOrigin === config.pageOrigin ? config.currency : null};
  }
  async function verifyOne(candidate, config, fetcher, signal) {
    var url = config.verifyOrigin + config.route + 'products/' + candidate.handle + '.js';
    var controller = new AbortController();
    var abort = () => controller.abort();
    if (signal && signal.aborted) return {product: null, unavailable: true};
    if (signal) signal.addEventListener('abort', abort, {once: true});
    var timer = setTimeout(abort, 6000);
    try {
      var response = await fetcher(url, {method: 'GET', credentials: config.verifyOrigin === config.pageOrigin ? 'same-origin' : 'omit', mode: 'cors', redirect: 'error', cache: 'no-store',
        referrerPolicy: 'no-referrer', headers: {'Accept': 'application/json'}, signal: controller.signal});
      if (response.status === 404 || response.status === 410) return {product: null, unavailable: false};
      if (!response.ok || response.redirected || response.url !== url) return {product: null, unavailable: true};
      var contentType = response.headers.get('content-type') || '';
      if (!/^(application\/json|text\/javascript|application\/javascript)\b/i.test(contentType)) return {product: null, unavailable: true};
      var raw = await response.text();
      if (raw.length > 2000000) return {product: null, unavailable: true};
      return {product: publicProduct(JSON.parse(raw), candidate, config), unavailable: false};
    } catch (_) { return {product: null, unavailable: true}; }
    finally { clearTimeout(timer); if (signal) signal.removeEventListener('abort', abort); }
  }
  async function verifyInOrder(items, config, fetcher, signal) {
    var results = new Array(items.length), next = 0;
    async function worker() {
      while (next < items.length && !(signal && signal.aborted)) {
        var index = next++; results[index] = await verifyOne(items[index], config, fetcher, signal);
      }
    }
    await Promise.all(Array.from({length: Math.min(3, items.length)}, worker));
    return results.filter(Boolean);
  }
  function recordCurrent(storage, snapshot, current, config) {
    try {
      if (!snapshot.available || !storage || storage.getItem(KEY) !== snapshot.raw) return false;
      if (snapshot.items[0] && snapshot.items[0].id === current.id) return true;
      var items = [current].concat(snapshot.items.filter(item => item.id !== current.id && item.handle !== current.handle)).slice(0, 12);
      // Only sanitized legacy-compatible fields are retained; no query strings or extra values.
      storage.setItem(KEY, JSON.stringify(items.map(item => ({id: Number.isSafeInteger(Number(item.id)) ? Number(item.id) : item.id, title: item.title || '', url: item.url, image: item.image || '', price: item.price == null ? null : item.price, currency: item.currency || null}))));
      return true;
    } catch (_) { return false; }
  }
  function renderCards(grid, products, document) {
    var fragment = document.createDocumentFragment();
    products.forEach(product => {
      var link = document.createElement('a'); link.className = 'hah-recent-link'; link.href = product.href; link.referrerPolicy = 'no-referrer';
      if (product.image) {
        var media = document.createElement('span'); media.className = 'hah-recent-media';
        var image = document.createElement('img'); image.src = product.image; image.alt = product.title;
        image.loading = 'lazy'; image.referrerPolicy = 'no-referrer'; image.width = 640; image.height = 640;
        image.addEventListener('error', function () { media.remove(); }, {once: true}); media.appendChild(image); link.appendChild(media);
      }
      var title = document.createElement('span'); title.className = 'hah-recent-name'; title.textContent = product.title;
      link.appendChild(title);
      if (Number.isSafeInteger(product.price) && product.price >= 0 && /^[A-Z]{3}$/.test(product.currency || '')) {
        try {
          var money = document.createElement('span'); money.className = 'hah-recent-price';
          money.textContent = new Intl.NumberFormat(document.documentElement.lang || undefined, {style: 'currency', currency: product.currency}).format(product.price / 100);
          link.appendChild(money);
        } catch (_) { /* Unknown currency/locale must not make an otherwise valid product disappear. */ }
      }
      fragment.appendChild(link);
    });
    grid.replaceChildren(fragment);
  }
  return {KEY: KEY, configuration: configuration, normalize: normalize, readHistory: readHistory,
    publicProduct: publicProduct, verifyInOrder: verifyInOrder, recordCurrent: recordCurrent, renderCards: renderCards};
}));
